<div class="card">
    <div class="card-body">
        <div class="mb-3">
            <div class="row">
                <div class="col-3">
                    <label class="form-label fw-bold">Servicio ID</label>
                    <input type="number" class="form-control" [(ngModel)]="filterServiceId"
                        (ngModelChange)="onFiltersChanged()" placeholder="Ej: 123">
                </div>
                <div class="col-3">
                    <label class="form-label fw-bold">Fecha creación</label>
                    <input type="date" class="form-control" [(ngModel)]="filterCreatedAt"
                        (ngModelChange)="onFiltersChanged()">
                </div>
            </div>
        </div>

        <div class="ag-theme-alpine" style="height: 600px; width: 100%;">
            <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [rowData]="rowData"
                [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [loadingCellRenderer]="loadingCellRenderer"
                [loadingCellRendererParams]="loadingCellRendererParams" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>
    <div class="card-footer d-flex justify-content-between align-items-center">
        <div></div>
        <div class="d-flex align-items-center">
            <label class="me-2">Filas por página:</label>
            <select class="form-select form-select-sm me-2" style="width: auto;" (change)="onPageSizeChanged($any($event.target).value)">
                <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{s}}</option>
            </select>
            <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()" [disabled]="currentPage <= 1">
                <i class="ti ti-chevron-left"></i>
            </button>
            <span class="me-2">Página {{currentPage}}</span>
            <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()" [disabled]="!hasNextPage">
                <i class="ti ti-chevron-right"></i>
            </button>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>